import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import estilos from './ChatComponent.module.css'
import ChatMessageComponent from './ChatMessageComponent';
import {
    faAngleLeft, faAngleRight, faCalendar, faPenToSquare, faTrash, faPerson, faComments,faEnvelope,faPaperPlane
} from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'

library.add(faAngleLeft, faAngleRight, faPenToSquare, faTrash, faPerson, faComments,faEnvelope,faPaperPlane)



function ChatComponent(props) {
    return (
        <div className='container'>
            <div className={`row ${estilos.cabecera}`}>
                <div className='col-2' style={{ paddingLeft: '3%' }}>
                    <img className='img-fluid rounded-circle' src='https://www.w3schools.com/howto/img_avatar.png' width={'70px'} />
                </div>
                <div className='col-10'>
                    <h3 className='text-light'> Inspector 1</h3>
                    <h3 className='text-light'> Zona: </h3>
                </div>
            </div>
            <div className={`row ${estilos.cuerpoChat}`}>

                <ChatMessageComponent tipoMensaje={2} texto={'Hola como estás? Ya vienes'}></ChatMessageComponent><br></br>
                <ChatMessageComponent tipoMensaje={1} texto={'Si ya terminé la inspección. Pasas por mi?'}></ChatMessageComponent>
                <ChatMessageComponent tipoMensaje={2} texto={'Hola como estás? Ya vienes'}></ChatMessageComponent><br></br>
                <ChatMessageComponent tipoMensaje={1} texto={'Si ya terminé la inspección. Pasas por mi?'}></ChatMessageComponent>
            </div>
            <br></br>

            <form action='/'>
                <div className='row'>
                    <div className='col-10'>
                        <input type='text' placeholder='Escribe tu mensaje' className='form-control' />
                    </div>
                    <div className='col-2'>
                        <button type='submit' className='btn btn-primary' style={{borderRadius:'50%'}}><FontAwesomeIcon icon={faPaperPlane} /></button>
                    </div>
                </div>
            </form>
            <br></br>
        </div>
    );
};


export default withRouter(ChatComponent)
